import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import './Styles/customBootstrap.scss';
import 'animate.css/animate.css';
import './Styles/Main.less';
import './Styles/Dashboard.less';
import 'react-datepicker/dist/react-datepicker.css';
import 'dayjs/locale/ru';
import { useContext } from 'react';
import { BrowserRouter as Router, Route } from 'react-router-dom';
import { UploadContextProvider } from '@yooink/youi/dist/Upload/UploadContext';
import momentRuLocale from 'moment/locale/ru';
import moment from 'moment';
import { i18nConfig } from 'shared/i18nconfig';
import { LocalizationProvider } from '@yooink/yoi18ncontextforms/es/LocalizationContext';
import { MantineProvider } from '@mantine/core';
import { DatesProvider } from '@mantine/dates';
import * as Theme from './Engine/Themes/LayoutLoader';
import { MainPage } from './Pages/Main';
import SystemRoute from './Pages/System/SystemRoute';
import { UserContext } from './Engine/Auth/UserContext';
import { UsersRoute } from './Pages/Users/UsersRoute';
import { NewsRoute } from './Pages/News/NewsRoute';
import { SitePagesRoute } from './Pages/SitePages/SitePagesRoute';
import { LeadsRoute } from './Pages/Leads/LeadsRoute';
import { ProductsRoute } from './Pages/Products/ProductsRoute';
import { OrdersRoute } from './Pages/Orders/OrdersRoute';
import { SettingsRoute } from './Pages/Settings/SettingsRoute';
import { ActionLoggerRoute } from './Pages/ActionLogger/ActionLoggerRoute';
import { AnalyticsRoute } from './Pages/Analytics/AnalyticsRoute';
import { PromocodesRoute } from './Pages/PromocodesAndCerts/promocodesRoute';
import { SelfDeliveryRouter } from './Pages/selfDelivery';
import { RecipesRoute } from './Pages/Recipes/RecipesRoute';
import { MailingListPage } from './Pages/MailingList';
import { ReportsRoute } from './Pages/Reports/reportsRoute';
import { UserRequestsPage } from './Pages/UserRequests';
import { B2bRoute } from './Pages/b2b/b2bRoute';
import { BadgeProvider } from './Components/BaidgeManager';
import { AutoGiftsRulesRoute } from './Pages/AutogiftsRules/autogiftsRulesRoute';
import { PromoModalsRoute } from './Pages/PromoModals/promoModalsRoute';
import { UploadProvider } from "./Api/Files";
import { ImageModerationPage } from "./Pages/ImageModeration";
import { AppSpotlight } from "./AppSpotlight";
import { SignupRewardRuleRoute } from './Pages/SignupRewardRule/SignupRewardRuleRoute';
import { AdventRoute } from './Pages/Advent/AdventRoute';
moment.updateLocale('ru', momentRuLocale);
moment.locale('ru');
document.title = 'YooinkSk - Панель управления';
export default function App() {
    const userCtx = useContext(UserContext);
    if (!userCtx.user) {
        return _jsx(Theme.AuthPage, {});
    }
    return (_jsx(Router, Object.assign({ basename: window.__BASE_URL || '/' }, { children: _jsx(MantineProvider, Object.assign({ withGlobalStyles: true, withNormalizeCSS: true }, { children: _jsx(AppSpotlight, { children: _jsx(DatesProvider, Object.assign({ settings: { locale: 'ru', firstDayOfWeek: 1, weekendDays: [0] } }, { children: _jsx(UploadContextProvider, Object.assign({ uploader: UploadProvider }, { children: _jsx(LocalizationProvider, Object.assign({ langs: i18nConfig.langs, defaultLang: i18nConfig.default }, { children: _jsx(BadgeProvider, { children: _jsxs(Theme.Layout, { children: [_jsx(Route, { exact: true, path: "/", component: MainPage }), _jsx(SystemRoute, {}), _jsx(NewsRoute, {}), _jsx(RecipesRoute, {}), _jsx(UsersRoute, {}), _jsx(SitePagesRoute, {}), _jsx(LeadsRoute, {}), _jsx(ProductsRoute, {}), _jsx(OrdersRoute, {}), _jsx(SettingsRoute, {}), _jsx(ActionLoggerRoute, {}), _jsx(AnalyticsRoute, {}), _jsx(PromocodesRoute, {}), _jsx(SelfDeliveryRouter, {}), _jsx(ReportsRoute, {}), _jsx(B2bRoute, {}), _jsx(AutoGiftsRulesRoute, {}), _jsx(PromoModalsRoute, {}), _jsx(SignupRewardRuleRoute, {}), _jsx(AdventRoute, {}), _jsx(Route, { path: "/mailingList", component: MailingListPage }), _jsx(Route, { path: "/requests", component: UserRequestsPage }), _jsx(Route, { path: '/uploadModeration', component: ImageModerationPage })] }) }) })) })) })) }) })) })));
}
